define(["text!js-translation.json"],(function(t){"use strict";return JSON.parse(t)}));